import { getLocalStorage, setLocalStorage } from "../../util/storageUtil";
import callAPI from "../callAPI";
import config from "../config";
import { getOATState } from "./oatBridge";

//**Compare if config version is same as in local storage */
export const shouldUpdateEnvProps = async (configVersion) => {
  const data = getLocalStorage("appConfig");
  if (data && data?.configVer) {
    if (
      configVersion !== null &&
      configVersion !== undefined &&
      data?.configVer !== configVersion
    ) {
      await callAppConfigApi();
    } else {
      return false;
    }
  }
};

//**Get App Config from strapi */
export const callAppConfigApi = async () => {
  try {
    let apiURL = config.api.appEnvProps.envProps;
    let apiResponse = await callAPI.get(apiURL);
    let regResponse = await apiResponse.json();
    if (apiResponse.status === 200) {
      const data = regResponse?.data?.[0]?.attributes || {};
      const updated = updateEnvProps(data);
      const props = regResponse?.data?.[0]?.attributes?.props || [];

      const gatewayURL = props.find(
        (x) => x?.title === "gatewayURL"
      )?.value;

      const oatGatewayURL = props.find(
        (x) => x?.title === "oatGatewayURL"
      )?.value;

      const { isOAT = false } = getOATState();

      const protectedApiUrl =
        isOAT && oatGatewayURL ? oatGatewayURL : gatewayURL;

      if (protectedApiUrl) {
        updateProtectedApis(protectedApiUrl);
      }

      if (updated["TEMPLATE_ID"] === "TemplateFour") {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = "/template/templatev4.css";
        link.id = "template-v4-style";
        document.head.appendChild(link);
      }

      return updated;
    } else {
      return true;
    }
  } catch (e) {
    console.log(e);
    return true;
  }
};

export const updateProtectedApis = (secondaryGatewayUrl) => {
  config.api.logout = `${secondaryGatewayUrl}/gw/api/logout`;
  config.api.user.info = `${secondaryGatewayUrl}/gw/api/user/info`;
  config.api.user.update = `${secondaryGatewayUrl}/pax2/v2/api/user/updateUser`;
  config.api.user.updateAccount = `${secondaryGatewayUrl}/pax2/v2/api/user/updateAccount`;
  config.api.user.updateProfileImage = `${secondaryGatewayUrl}/pax2/v2/api/user/image/profile/save`;
  config.api.user.delete = `${secondaryGatewayUrl}/gw/api/user/delete`;
  config.api.user.referral_check = `${secondaryGatewayUrl}/pax2/v2/api/user/lms/referral/check`;
  config.api.user.become_member = `${secondaryGatewayUrl}/pax2/v2/api/user/lms/membership/apply`;
  config.api.user.membership_status = `${secondaryGatewayUrl}/pax2/v2/api/user/lms/membership/status`;
  config.api.user.requestOtpUpdateEmail = `${secondaryGatewayUrl}/gw/api/user/request/update/email/:email`;
  config.api.user.updateEmail = `${secondaryGatewayUrl}/gw/api/user/update/email`;
  config.api.user.requestOtpUpdateMobile = `${secondaryGatewayUrl}/gw/api/user/request/update/mobile/:mobile`;
  config.api.user.updateMobile = `${secondaryGatewayUrl}/gw/api/user/update/mobile`;
  config.api.user.communication.channels = `${secondaryGatewayUrl}/pax2/v2/api/user/communication/channels`;
  config.api.user.communication.preferences = `${secondaryGatewayUrl}/pax2/v2/api/user/communication/preferences`;
  config.api.cart.myCartV2 = `${secondaryGatewayUrl}/pax2/v2/api/cart/v2/mycart`;
  config.api.cart.saveCartV2 = `${secondaryGatewayUrl}/pax2/v2/api/cart/v2/save`;
  config.api.cart.summaryV2 = `${secondaryGatewayUrl}/pax2/v2/api/cart/v2/summary`;
  config.api.payment.gatewayConfiguration = `${secondaryGatewayUrl}/pax2/v2/api/payment/gatewayConfiguration`;
  config.api.payment.completeOrder = `${secondaryGatewayUrl}/pax2/v2/api/order/complete`;
  config.api.payment.orderSummaryV2 = `${secondaryGatewayUrl}/pax2/v2/api/order/summary`;
  config.api.payment.orderStatus = `${secondaryGatewayUrl}/pax2/v2/api/order/orderStatus`;
  config.api.payment.alternateStores = `${secondaryGatewayUrl}/pax2/v2/api/order/alternateStores`;
  config.api.payment.retryPayment = `${secondaryGatewayUrl}/pax2/v2/api/order/retryPayment`;
  config.api.checkout.checkoutV2 = `${secondaryGatewayUrl}/pax2/v2/api/cart/v2/checkout`;
  config.api.myOrders.activeOrders = `${secondaryGatewayUrl}/pax2/v2/api/order/active`;
  config.api.myOrders.pastOrders = `${secondaryGatewayUrl}/pax2/v2/api/order/past`;
  config.api.myOrders.cancelService = `${secondaryGatewayUrl}/pax2/v2/api/order/cancel`;
  config.api.helpAndSupport.assistMe = `${secondaryGatewayUrl}/helpdesk/api/assist/me`;
  config.api.helpAndSupport.createTicket = `https://getgrab.freshdesk.com/api/v2/tickets/`;
  config.api.helpAndSupport.ticketListing = `${secondaryGatewayUrl}/helpdesk/api/ticket/list`;
  config.api.auth.initiate = `${secondaryGatewayUrl}/register/initiate`;
  config.api.auth.validate = `${secondaryGatewayUrl}/register/validate`;
  config.api.braintreePayment.paymentProcess = `${secondaryGatewayUrl}/pax2/v2/api/payment/braintree/processPayment`;
  config.api.getCoupons = `${secondaryGatewayUrl}/promotions/v1/api/promotion/getCoupons`;
  config.api.login.local = `${secondaryGatewayUrl}/login/local`;
  config.api.login.otp = `${secondaryGatewayUrl}/login/otp`;
  config.api.login.refresh = `${secondaryGatewayUrl}/login/refresh`;
  config.api.captive.getOtp = `${secondaryGatewayUrl}/login/captive/otp`;
  config.api.captive.local = `${secondaryGatewayUrl}/login/captive/local`;
  config.api.employeeRegister = `${secondaryGatewayUrl}/gw/api/employee/enroll/empId`;
  config.api.employeeUnRegister = `${secondaryGatewayUrl}/gw/api/employee/delist`;
  config.api.npsFeedback.pendingItem = `${secondaryGatewayUrl}/feedback/api/pending/item`;
  config.api.npsFeedback.saveItem = `${secondaryGatewayUrl}/feedback/api/save/item`;
  config.api.npsFeedback.pendingRapidfire = `${secondaryGatewayUrl}/feedback/api/pending/rapidfire/item`;
  config.api.npsFeedback.saveRapidfireItem = `${secondaryGatewayUrl}/feedback/api/save/rapidfire/item`;
  config.api.npsFeedback.saveRapidfireOverall = `${secondaryGatewayUrl}/feedback/api/save/rapidfire/overall`;
  config.api.npsFeedback.askLater = `${secondaryGatewayUrl}/feedback/api/later`;
  config.api.guest.guestLogin = `${secondaryGatewayUrl}/login/guest`;
  config.api.guest.updateUser = `${secondaryGatewayUrl}/pax2/v2/api/user/updateUser`;
  config.api.auth.userValidate = `${secondaryGatewayUrl}/login/otp`;
  config.api.updateDocument = `${secondaryGatewayUrl}/gw/api/user/update/documents`;
  config.api.getFlightTrackData = `${secondaryGatewayUrl}/fis/v2/api/flightAlert/getData`;
  config.api.flightTrack = `${secondaryGatewayUrl}/fis/v2/api/flightAlert/create`;
  config.api.stopFlightTrack = `${secondaryGatewayUrl}/fis/v2/api/flightAlert/stop`;
  config.api.allergen = `${secondaryGatewayUrl}/pax2/v2/api/products/masterAllergen`;
  config.api.tableNoValidate = `${secondaryGatewayUrl}/pax2/v2/api/shops/validateTable`;
  config.api.eReceipt = `${secondaryGatewayUrl}/pax2/v2/api/order/invoice`;
  config.api.products.getProductsByStore = `${secondaryGatewayUrl}/pax2/v2/api/products/category`;
};

//**Update local storage */
export const updateEnvProps = (data) => {
  let configObj = { ...data };
  data?.flags?.forEach((x) => {
    configObj[x.title] = x.value;
  });
  data?.props?.forEach((x) => {
    configObj[x.title] = x.value;
  });
  setLocalStorage("appConfig", configObj);

  return configObj;
};

//**Check app config */
export const getAppConfig = (key) => {
  let appConfig = getLocalStorage("appConfig");

  if (appConfig) {
    return appConfig[key];
  } else {
    let config = false;
    config = import.meta.env[`REACT_APP_${key}`];
    if (config === "true") {
      config = true;
    } else if (config === "false") {
      config = false;
    }
    return config;
  }
};


//is app config available
export const isAppConfigLoaded = () => {
  let appConfig = getLocalStorage("appConfig");
  if (appConfig) {
    return true;
  }
};

export const getAllowedCountryCodes = () => {
  try {
    return getAppConfig("ALLOWED_COUNTRY_CODES").split(",") || [];
  } catch (e) { }
  return [];
};
